import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import { MentionList } from '../components/MentionList';
import { getNoticeEditorPortalRoot } from '../utils/portalRoot';
export default function getSuggestion(getVariables) {
    return {
        items: ({ query }) => {
            return [...getVariables()]
                .sort((a, b) => (a.label || a.key || '').localeCompare(b.label || b.key || '', undefined, { numeric: true, sensitivity: 'base' }))
                .filter((item) => item.label.toLowerCase().includes(query.toLowerCase()))
                .slice(0, 100);
        },
        render: () => {
            let component;
            let popup;
            return {
                onStart: (props) => {
                    component = new ReactRenderer(MentionList, {
                        props,
                        editor: props.editor,
                    });
                    if (!props.clientRect) {
                        return;
                    }
                    popup = tippy('body', {
                        getReferenceClientRect: props.clientRect,
                        // Appended to the feature's scoped portal container rather than
                        // <body>, so the suggestion popover keeps its styling in JustAct-CM.
                        appendTo: () => getNoticeEditorPortalRoot() || document.body,
                        content: component.element,
                        showOnCreate: true,
                        interactive: true,
                        trigger: 'manual',
                        placement: 'bottom-start',
                    });
                },
                onUpdate(props) {
                    component.updateProps(props);
                    if (!props.clientRect) {
                        return;
                    }
                    popup[0].setProps({
                        getReferenceClientRect: props.clientRect,
                    });
                },
                onKeyDown(props) {
                    if (props.event.key === 'Escape') {
                        popup[0].hide();
                        return true;
                    }
                    return component.ref?.onKeyDown(props);
                },
                onExit() {
                    popup[0].destroy();
                    component.destroy();
                },
            };
        },
        command: ({ editor, range, props }) => {
            editor
                .chain()
                .focus()
                .insertContentAt(range, [
                {
                    type: 'variableTag',
                    attrs: {
                        variableKey: props.key,
                        label: props.label,
                    },
                },
                {
                    type: 'text',
                    text: ' ',
                },
            ])
                .run();
        },
    };
}
